var map = {
	"./AD.png": 160,
	"./AE.png": 161,
	"./AF.png": 162,
	"./AG.png": 163,
	"./AM.png": 164,
	"./AO.png": 165,
	"./AR.png": 166,
	"./AT.png": 167,
	"./AU.png": 168,
	"./AZ.png": 169,
	"./BA.png": 170,
	"./BB.png": 171,
	"./BD.png": 172,
	"./BE.png": 173,
	"./BF.png": 174,
	"./BG.png": 175,
	"./BH.png": 176,
	"./BI.png": 177,
	"./BJ.png": 178,
	"./BN.png": 179,
	"./BO.png": 180,
	"./BR.png": 181,
	"./BS.png": 182,
	"./BT.png": 183,
	"./BW.png": 184,
	"./BY.png": 185,
	"./BZ.png": 186,
	"./CA.png": 187,
	"./CD.png": 188,
	"./CF.png": 189,
	"./CH.png": 190,
	"./CI.png": 191,
	"./CL.png": 192,
	"./CM.png": 193,
	"./CN.png": 194,
	"./CO.png": 195,
	"./CR.png": 196,
	"./CS.png": 197,
	"./CU.png": 198,
	"./CV.png": 199,
	"./CY.png": 200,
	"./CZ.png": 201,
	"./DE.png": 202,
	"./DJ.png": 203,
	"./DK.png": 204,
	"./DM.png": 205,
	"./DO.png": 206,
	"./DZ.png": 207,
	"./EC.png": 208,
	"./EE.png": 209,
	"./EG.png": 210,
	"./ER.png": 211,
	"./ES.png": 212,
	"./ET.png": 213,
	"./FI.png": 214,
	"./FJ.png": 215,
	"./FM.png": 216,
	"./FR.png": 217,
	"./GA.png": 218,
	"./GB.png": 219,
	"./GD.png": 220,
	"./GE.png": 221,
	"./GH.png": 222,
	"./GM.png": 223,
	"./GN.png": 224,
	"./GQ.png": 225,
	"./GR.png": 226,
	"./GT.png": 227,
	"./GW.png": 228,
	"./GY.png": 229,
	"./HK.jpg": 230,
	"./HN.png": 231,
	"./HR.png": 232,
	"./HT.png": 233,
	"./HU.png": 234,
	"./ID.png": 235,
	"./IE.png": 236,
	"./IL.png": 237,
	"./IN.png": 238,
	"./IQ.png": 239,
	"./IR.png": 240,
	"./IS.png": 241,
	"./IT.png": 242,
	"./JM.png": 243,
	"./JO.png": 244,
	"./JP.png": 245,
	"./KE.png": 246,
	"./KG.png": 247,
	"./KH.png": 248,
	"./KI.png": 249,
	"./KM.png": 250,
	"./KN.png": 251,
	"./KP.png": 252,
	"./KR.png": 253,
	"./KW.png": 254,
	"./KZ.png": 255,
	"./LA.png": 256,
	"./LB.png": 257,
	"./LC.png": 258,
	"./LI.png": 259,
	"./LK.png": 260,
	"./LR.png": 261,
	"./LS.png": 262,
	"./LT.png": 263,
	"./LU.png": 264,
	"./LV.png": 265,
	"./LY.png": 266,
	"./MA.png": 267,
	"./MC.png": 268,
	"./MD.png": 269,
	"./ME.png": 270,
	"./MG.png": 271,
	"./MH.png": 272,
	"./MK.png": 273,
	"./ML.png": 274,
	"./MM.png": 275,
	"./MN.png": 276,
	"./MR.png": 277,
	"./MT.png": 278,
	"./MU.png": 279,
	"./MV.png": 280,
	"./MW.png": 281,
	"./MX.png": 282,
	"./MY.png": 283,
	"./MZ.png": 284,
	"./NA.png": 285,
	"./NE.png": 286,
	"./NG.png": 287,
	"./NI.png": 288,
	"./NL.png": 289,
	"./NO.png": 290,
	"./NP.png": 291,
	"./NR.png": 292,
	"./NU.png": 293,
	"./NZ.png": 294,
	"./OM.png": 295,
	"./PA.png": 296,
	"./PE.png": 297,
	"./PG.png": 298,
	"./PH.png": 299,
	"./PK.png": 300,
	"./PL.png": 301,
	"./PT.png": 302,
	"./PW.png": 303,
	"./PY.png": 304,
	"./QA.png": 305,
	"./RO.png": 306,
	"./RS.png": 307,
	"./RU.png": 308,
	"./RW.png": 309,
	"./SA.png": 310,
	"./SB.png": 311,
	"./SC.png": 312,
	"./SD.png": 313,
	"./SE.png": 314,
	"./SG.png": 315,
	"./SI.png": 316,
	"./SK.png": 317,
	"./SL.png": 318,
	"./SM.png": 319,
	"./SN.png": 320,
	"./SO.png": 321,
	"./SR.png": 322,
	"./SS.png": 323,
	"./ST.png": 324,
	"./SV.png": 325,
	"./SY.png": 326,
	"./SZ.png": 327,
	"./TD.png": 328,
	"./TG.png": 329,
	"./TH.png": 330,
	"./TJ.png": 331,
	"./TL.png": 332,
	"./TM.png": 333,
	"./TN.png": 334,
	"./TO.png": 335,
	"./TR.png": 336,
	"./TT.png": 337,
	"./TV.png": 338,
	"./TW.png": 339,
	"./TZ.png": 340,
	"./UA.png": 341,
	"./UG.png": 342,
	"./UK.png": 343,
	"./US.png": 344,
	"./UY.png": 345,
	"./UZ.png": 346,
	"./VA.png": 347,
	"./VC.png": 348,
	"./VE.png": 349,
	"./VN.png": 350,
	"./WS.png": 351,
	"./YE.png": 352,
	"./ZA.png": 353,
	"./ZM.png": 354,
	"./ZW.png": 355,
	"./congo-republic-of-the-flag-xl.png": 356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 159;